const RoutesToPages = {
  mainPage: "/",
  selectedCity: "selectedCity/",
};

export default RoutesToPages;
